import { render, staticRenderFns } from "./index.vue?vue&type=template&id=566c8f42&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c8f42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566c8f42')) {
      api.createRecord('566c8f42', component.options)
    } else {
      api.reload('566c8f42', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=566c8f42&scoped=true", function () {
      api.rerender('566c8f42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/bargain/index.vue"
export default component.exports